// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ClubQuestionsController from "./club_questions_controller"
application.register("club-questions", ClubQuestionsController)

import ClubSettingsTabsController from "./club_settings_tabs_controller"
application.register("club-settings-tabs", ClubSettingsTabsController)

import ClubThemeColorController from "./club_theme_color_controller"
application.register("club-theme-color", ClubThemeColorController)

import ClubsMapController from "./clubs_map_controller"
application.register("clubs-map", ClubsMapController)

import CountryCodeSelectorController from "./country_code_selector_controller"
application.register("country-code-selector", CountryCodeSelectorController)

import DropzoneController from "./dropzone_controller"
application.register("dropzone", DropzoneController)

import EmailCheckController from "./email_check_controller"
application.register("email-check", EmailCheckController)

import EmergencyContactDetailsController from "./emergency_contact_details_controller"
application.register("emergency-contact-details", EmergencyContactDetailsController)

import GuardianDetailsController from "./guardian_details_controller"
application.register("guardian-details", GuardianDetailsController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import IdentityDocumentController from "./identity_document_controller"
application.register("identity-document", IdentityDocumentController)

import LocationPickerController from "./location_picker_controller"
application.register("location-picker", LocationPickerController)

import LoginMethodController from "./login_method_controller"
application.register("login-method", LoginMethodController)

import MembershipFiltersController from "./membership_filters_controller"
application.register("membership-filters", MembershipFiltersController)

import MembershipQuestionFormController from "./membership_question_form_controller"
application.register("membership-question-form", MembershipQuestionFormController)

import MembershipStartController from "./membership_start_controller"
application.register("membership-start", MembershipStartController)

import MembershipTypePreviewController from "./membership_type_preview_controller"
application.register("membership-type-preview", MembershipTypePreviewController)

import MembershipsSelectionController from "./memberships_selection_controller"
application.register("memberships-selection", MembershipsSelectionController)

import MobileCheckController from "./mobile_check_controller"
application.register("mobile-check", MobileCheckController)

import MobileNumberController from "./mobile_number_controller"
application.register("mobile-number", MobileNumberController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import PaymentConfirmationController from "./payment_confirmation_controller"
application.register("payment-confirmation", PaymentConfirmationController)

import PaymentMethodController from "./payment_method_controller"
application.register("payment-method", PaymentMethodController)

import PaymentPlanSelectorController from "./payment_plan_selector_controller"
application.register("payment-plan-selector", PaymentPlanSelectorController)

import PaymentProcessingController from "./payment_processing_controller"
application.register("payment-processing", PaymentProcessingController)

import PreorderHideController from "./preorder_hide_controller"
application.register("preorder-hide", PreorderHideController)

import PreviousClubQuestionController from "./previous_club_question_controller"
application.register("previous-club-question", PreviousClubQuestionController)

import SaIdController from "./sa_id_controller"
application.register("sa-id", SaIdController)

import SizeCurveSortController from "./size_curve_sort_controller"
application.register("size-curve-sort", SizeCurveSortController)

import SquadController from "./squad_controller"
application.register("squad", SquadController)

import StaggeredPaymentPlanController from "./staggered_payment_plan_controller"
application.register("staggered-payment-plan", StaggeredPaymentPlanController)

import StockQuantitySelectorController from "./stock_quantity_selector_controller"
application.register("stock-quantity-selector", StockQuantitySelectorController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import PendingOrderGuardController from "./pending_order_guard_controller"
application.register("pending-order-guard", PendingOrderGuardController)

import CancelCartController from "./cancel_cart_controller"
application.register("cancel-cart", CancelCartController)

import ClubSearchController from "./club_search_controller"
application.register("club-search", ClubSearchController)
